module.exports = __webpack_public_path__ + "static/img/zdhf02.feb9cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf02.png
// module id = 119
// module chunks = 0